module.exports = __webpack_public_path__ + "img/menu_logo.2baa1cdd.png";